// Import global sass.
// > import sub sass files inside main.scss
import './assets/sass/main.scss';

import { createApp } from 'vue';
import App from './App.vue';
import router, { handleNavigationGuard } from './router/router';

//global variables
import config from './config';
import packagejson from '../package.json';

//dependable functions
import ComponentRepo from './services/ComponentRepo';
import AppInitializer from './services/AppInitializer';
import DataDecorator from './services/DataDecorator';
import CreateSiteManifestLoader from './services/FetchSiteManifest';
import store from './store/store';
import Preloader from './services/Preloader';
import ApiManager from './services/api/ApiManager';


// app data in global space
window.app = {
    name: config.name,
    version: packagejson.version,
    manifest: false,
    externalManifest:null,
    api: {},
    defaultLanguage: config.defaultLanguage
}

// Load manifest to create pseudo pages
const manifestLoader = CreateSiteManifestLoader({
    DataDecorator: (manifest) => {
        return DataDecorator(manifest, app.api.Utils)
    }
})


AppInitializer()
// ------------- Add steps here to run during load of SPA -------------- //

// initialize pre runtime api
.addStep({
    id: 'api-manager',
    tasks: [{
        id: 'initialize-pre-apis',
        execute: () => ApiManager(app).initializePreApis()
    }]
})
// initialize manifest fetching from endpoint
.addStep({
    id: 'data-load',
    tasks: [{
        id: 'fetch-manifest',
        execute: () => manifestLoader.fetchData()
    }]
})

// DEIF
// initialize external manifest fetching from endpoint
.addStep({
    id: 'external-data-load',
    tasks: [{
        id: 'fetch-external-manifest',
        execute: () => manifestLoader.fetchExternalData()
    }]
})
// preload visual assets such as images and video
.addStep({
    id: 'preload',
    tasks: [{
        id: 'preload-backgrounds',
        execute: () => Preloader(app).preLoadBackgrounds()
    }, {
        id: 'preload-assets',
        execute: () => Preloader(app).preloadAssets()
    }]
})
// initialize post runtime api
.addStep({
    id: 'api-manager',
    tasks: [{
        id: 'initialize-post-apis',
        execute: () => ApiManager(app).initializePostApis()
    }
    ]
})
// Start the app when above steps have been run
.start(() => {
    // Load manifest into global object for fast and easy access
    app.manifest = manifestLoader;

    // Init app
    const vm = createApp(App);
    ComponentRepo.setup(vm)
    vm.use(store)
    vm.use(router);
    vm.mount('#app');
})
.then(() => {
    store.dispatch('loadRestrictedAccess')
    // Get video Transitions
    store.commit('storeVideoTransitions')

    //Check if page without content component exists or redirect to HomePage
    let route = window.app.vm.$route.path.split(":")[0];
    if (!app.api.PageManager.pageExists(route)) {
        //TODO:
        //Navigate til noget error 404 handling i stedet for homepage
        app.api.PageManager.navigateToHomePage().then(() => {
            store.commit('ready')
        })
    } else {
        store.commit('ready')
    }

    // Disable zooming on touch devices
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
        document.addEventListener('touchmove', function (event) {
            if (event.scale !== 1) {
                event.preventDefault();
            }
        }, { passive: false });
                    
        document.ondblclick = function(e) {
            e.preventDefault();
        }
    }
})
.then(() => {
    // trigger router to make sure a redirect happens for a deeplink within a page the user has no access to (behind lockedHotspot)
    handleNavigationGuard(router.currentRoute.value, {}, () => {});
})